export default __webpack_public_path__ + "static/media/refer-a-host-page-desktop.ce94cb38.png";